import { EnvironmentalType } from "enum/EnvironmentalType";
import { useCallback, useEffect, useState } from "react";
import { useStores } from "stores/setup/use-store";
import { intervalTime } from "../utils";

export function useSelectedStation() {
  const [selectedStation, setSelectedStation] = useState("");
  const {
    dataStores: { forecastChartPageStore },
  } = useStores();

  const onChangeSelectedStation = (station: string) => {
    const [stationId, regionId] = station.split("-");
    setSelectedStation(`${stationId}-${regionId}`);
  };

  const handleGetStations = useCallback(async () => {
    await forecastChartPageStore.getStationsForecastChartAPI(
      EnvironmentalType.WEATHER
    ); // EnvironmentalType ignored by Backend!
    setSelectedStation(
      `${forecastChartPageStore.selectedStation}-${forecastChartPageStore.regionId}`
    );
  }, [forecastChartPageStore]);

  useEffect(() => {
    handleGetStations();
    const interval = setInterval(() => {
      handleGetStations();
    }, intervalTime);

    return () => {
      clearInterval(interval);
    };
  }, [handleGetStations]);

  return {
    selectedStation,
    onChangeSelectedStation,
  };
}
